@if (ErrorMessage != null) {
  <div>
    @if (ErrorMessage) {
      <span class="help is-danger">
        {{ErrorMessage}}
        <!-- <span *ngIf="For != null && For.errors != null">
        <span *ngFor="let e of For.errors">
          {{ErrorDefs[e]}}
        </span>
      </span> -->
    </span>
  }
</div>
}